module.exports = __webpack_public_path__ + "img/full6-min.83c51f04.png";